import { Modal, Button } from "antd"
import { WarningOutlined } from "@ant-design/icons"
import { useTranslation } from "react-i18next"
import styles from "./ProNewListingLayout.module.css"
import IconWithBg from "ui/IconWithBg"
import PropTypes from "prop-types"

const ConnectStripeModal = ({ open, onCancel, onConnect }) => {
  const { t } = useTranslation()

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      centered
      closable
      width={480}
      title={
        <div className="text-center">
          <IconWithBg className={styles.iconCircle} icon={<WarningOutlined style={{ color: "#faad14", fontSize: 32 }} />} />
        </div>
      }
    >
      <>
        <div className={styles.modalTitle}>{t("experiences.stripe_modal.warning")}</div>
        <div className={styles.modalText}>
          {t("experiences.stripe_modal.description_1")}
          <br />
          {t("experiences.stripe_modal.description_2")}
        </div>
        <Button type="primary" size="large" onClick={onConnect}>
          {t("experiences.stripe_modal.button")}
        </Button>
      </>
    </Modal>
  )
}

ConnectStripeModal.propTypes = {
  open: PropTypes.bool,
  onCancel: PropTypes.func,
  onConnect: PropTypes.func
}

export default ConnectStripeModal
